import { FC, SVGProps } from 'react';

export const ActivityAdditionalItemIcon: FC<SVGProps<SVGSVGElement>> = ({ ...props }) => (
  <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="16.5" cy="16.75" r="16" fill="#B5D3EF" />
    <rect x="9.5" y="9.75" width="14" height="14" rx="1.5" stroke="#204366" />
    <path d="M13.1562 17.1445H17.4984" stroke="#204366" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13.1562 20.3027H19.8668" stroke="#204366" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
